import Header from "./header";
import {Container, Tab, Tabs} from "react-bootstrap";
import WordTest from "./WordTest";
import Unscramble from "./Unscramble";
import React from "react";

function Wordmenu() {
    return (
        <>
            <Header/>
            <Container as={'main'} className={'mt-2'}>
                <Tabs defaultActiveKey='word' className={'my-2'}>
                    <Tab eventKey='word' title='단어 암기'>
                        <WordTest/>
                    </Tab>
                    <Tab eventKey='scramble' title='문장 배열'>
                        <Unscramble/>
                    </Tab>
                </Tabs>
            </Container>
        </>
    );
}

export default Wordmenu;